<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import copyToClipBoard from '@utils/copy-to-clipboard'
import SocialShare from '@components/social-share'
import { useAppearanceStore } from '@state/stores/appearance'
import { useMessages } from '@composables/use-messages'

const props = defineProps({
    show: {
        type: Object,
        default: () => {},
    },
    hasViewShowOption: {
        type: Boolean,
        default: true,
    },
})

const appearanceStore = useAppearanceStore()
const router = useRouter()
const getMessageText = useMessages()

const url = computed(() => {
    // Router 4 throws on a falsy required param, and this resolves during render.
    if (!props.show.id) return ''

    const { protocol, hostname, port } = window.location
    const href = router.resolve({ name: 'show', params: { id: props.show.id } }).href
    return `${protocol}//${hostname}${port ? ':' + port : ''}${href}`
})

function copyLinkToClipBoard() {
    copyToClipBoard(url.value)
    appearanceStore.handleNotification({
        message: getMessageText('LINK_COPIED_CLIPBOARD'),
        type: 'success',
    })
}
</script>

<template>
    <ul class="show-options">
        <li
            v-if="hasViewShowOption"
            class="show-options-item"
            @click="router.push({ name: 'show', params: { id: show.id } })"
        >
            <BaseButton
                icon="eye"
                size="medium"
                button-type="transparent"
                @click="() => {}"
            >&nbsp; View Show</BaseButton>
        </li>
        <div
            v-if="hasViewShowOption"
            class="separator"
        />

        <li class="show-options-item">
            <BaseFavourites
                v-if="show"
                :show="show"
                size="medium"
                button-type="transparent"
                icon-main="user-minus"
                icon-alt="user-plus"
            >
                <template #main>
                    <span>Follow Show</span>
                </template>
                <template #alt>
                    <span>Following</span>
                </template>
            </BaseFavourites>
        </li>
        <h6 class="share-title">Share</h6>
        <div class="separator" />
        <li class="show-options-item">
            <BaseButton
                icon="facebook"
                size="medium"
                button-type="transparent"
            >
                <SocialShare
                    :url="url"
                    type="facebook"
                />
            </BaseButton>
        </li>
        <li class="show-options-item">
            <BaseButton
                icon="twitter"
                size="medium"
                button-type="transparent"
            >
                <SocialShare
                    :url="url"
                    :custom-text="`${show.title} on @friskyradio #feelinfrisky`"
                    type="twitter"
                />
            </BaseButton>
        </li>
        <li
            class="show-options-item"
            @click="copyLinkToClipBoard"
        >
            <BaseButton
                icon="link"
                size="medium"
                button-type="transparent"
                @click="() => {}"
            >&nbsp;Copy Show link</BaseButton>
        </li>
    </ul>
</template>

<style lang="scss" scoped>
@import '@design';

.show-options {
    padding: 0;
    margin: 0;
    text-align: left;
    list-style: none;

    &-item {
        display: flex;
        align-items: center;
        height: 44px;
        padding: 0 $s-m;
    }
}

.separator {
    position: relative;
    display: block;
    width: 100%;
    height: 1px;
    background: $c-mine-shaft;
}

.share-title {
    @extend %contentTitleM;

    margin: $s-s 0 $s-s $s-xl;
}
</style>
